/**
 * Partial mapping of result from ecdn10 agent call: api/v1/downloadMonitor
 */
export default class MonitorData {
  internalIPAddress?: string;
  gatewayIPAddress?: string;
  externalIPAddress?: string;
  arenaGroup?: string;
  arenaId?: number;

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  constructor(obj?: any) {
    this.internalIPAddress = obj && obj.internalIPAddress;
    this.gatewayIPAddress = obj && obj.gatewayIPAddress;
    this.externalIPAddress = obj && obj.externalIPAddress;
    this.arenaGroup = obj && obj.arenaGroup;
    this.arenaId = obj && obj.arenaId;
  }
}
